export default class News {
    constructor(option) {
        this.apiManager = option.apiManager;
    }

    headlines(params) {
        return this.apiManager.getNewsHeadlines(params);
    }

    view(params) {
        return this.apiManager.getNewsView(params);
    }

    mostViewed(params) {
        return this.apiManager.getNewsMostViewed(params);
    }

    logos(productCode, ids, size) {
        return this.apiManager.getNewsLogos(productCode, ids, size);
    }

    sources(productCode, status) {
        return this.apiManager.getNewsSources(productCode, status);
    }

    vendors(productCode) {
        return this.apiManager.getNewsVendors(productCode);
    }
}
